import React from 'react';
import CopyTextIconButton from '../CopyTextIconButton/CopyTextIconButton';

type CopyStudentNameButtonProps = {
  studentName: string;
};

const CopyStudentNameButton: React.FC<CopyStudentNameButtonProps> = ({ studentName }) => (
  <CopyTextIconButton value={studentName} ariaLabel="Copiar nome da aluna" />
);

export default CopyStudentNameButton;
